import ExamModel from '@/dex-shared/models/ExamModel';

export default {
  examByExamId: (state: any, getters: any) => (examId: number) => {
    let exam = state.exams[examId];
    if (exam) {
      return new ExamModel(exam, getters);
    } else {
      return null;
    }
  },
};
